import { render, staticRenderFns } from "./PageServiceDetail.vue?vue&type=template&id=50b47d54&scoped=true"
import script from "./PageServiceDetail.vue?vue&type=script&lang=js"
export * from "./PageServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./PageServiceDetail.vue?vue&type=style&index=0&id=50b47d54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b47d54",
  null
  
)

export default component.exports